<div
  class="info-tool d-flex flex-column position-relative"
  cdkOverlayOrigin
  #tooltipOrigin="cdkOverlayOrigin"
  (mouseenter)="isTooltipOpen = true"
  (mouseleave)="isTooltipOpen = false"
>
  <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="tooltipOrigin"
  [cdkConnectedOverlayOpen]="isTooltipOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="false"
>
  <div
    class="tooltip-info shadow-md"
    (mouseenter)="isTooltipOpen = true"
    (mouseleave)="isTooltipOpen = false"
  >

  <div class="d-flex justify-content-start mt-4 ml-4">
    <img src="../../../assets/icons/search-result/hotel/01_flecha.svg" style="width: 15px;" alt="">
  </div>
   
    <div style="position: relative">

        <!-- <div class="triangle"></div> -->

       

    <table class="table-info-tool">
      <tr>
        <th class="px-4" style="text-align: center">
          <div class="d-flex align-items-center" style="min-height: 45px;border-bottom: 1px solid #ececec;">
            <p class="mb-0" style="text-transform: capitalize;color: #ffffff">Cambio</p>
          </div>
        </th>
      </tr>
      <ng-container *ngFor="let currency of currencies; let i = index">
        <tr *ngIf="currency.code !== currencyAgency?.code" >
         <td class="d-flex align-items-center px-4" style="height: 38px;">
          <p class="mb-0" >
            <span style="color: #ffffff;font-weight: 500;"> {{ currency.code }}</span>
            <span style="font-weight: 500; color: #ffffff;">&nbsp;&nbsp;{{
                                valueProduct
                              | currencyConverter:
                                    currencyProduct:
                                    currencyAgency?.code:
                                    currencies
                              | currencyConverter:
                                    currencyAgency?.code:
                                    currency.code:
                                    currencies
                              | number: '1.2-2'
                            }}
              </span>
            </p>
          </td>
        </tr>
      </ng-container>
    </table>

    </div>
  </div>
</ng-template>
